import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  labelId: string;
  labelValues?: Record<string, string>;
  children: ReactNode;
}

export default function ScheduleInfoRow({ labelId, labelValues, children }: Props) {
  return (
    <div className="space-y-0.5">
      <div className="text-xs font-medium text-slate-500">
        <FormattedMessage id={labelId} values={labelValues} />
      </div>
      <div className="min-w-0 break-words text-sm text-slate-800">
        {children}
      </div>
    </div>
  );
}
